import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "module-notifications-parent" }
const _hoisted_2 = { class: "d-flex justify-center align-center h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_progress_linear, {
        color: "mpBlue",
        height: "2",
        indeterminate: "",
        rounded: "",
        class: "w-10"
      })
    ])
  ]))
}